import { isAfter, isSameHour } from '@e3dc-react/shell/Libs/date'
import { ForecastPower } from 'src/Libs/system-data-handler'
import { getLocalizedValueWithPrefix } from 'src/Libs/system-data-handler/utils/formatNumberWithSIPrefix'
import { UnitTypes } from 'src/Libs/types'
import { PvForecastWidgetChartDataItem, PvForecastWidgetValueAndUnit } from '../types'

/* returns the value and unit to display for the Pv Forecast Widget  */
export const getPvForecastWidgetValueAndUnit = (
  forecastPowerData: ForecastPower[],
  showRemainingProduction: boolean
): PvForecastWidgetValueAndUnit => {
  const now = new Date()
  const summedForecastPowerValue = forecastPowerData
    .filter(forecastPower => (showRemainingProduction ? isAfter(forecastPower.time, now) || isSameHour(forecastPower.time, now) : true))
    .reduce((acc, curr) => acc + (curr?.power || 0), 0)
  const { localizedValue, prefix } = getLocalizedValueWithPrefix(summedForecastPowerValue, 1)
  if (prefix === 'G') return { value: localizedValue, unit: UnitTypes.gigaWattHour }
  if (prefix === 'M') return { value: localizedValue, unit: UnitTypes.megaWattHour }
  if (prefix === 'k') return { value: localizedValue, unit: UnitTypes.kiloWattHour }
  return { value: localizedValue, unit: UnitTypes.wattHour }
}

/* returns the mapped data to use for the Pv Forecast Widget chart  */
export const getPvForecastWidgetChartData = (
  forecastPowerData: ForecastPower[],
  showRemainingProduction: boolean
): PvForecastWidgetChartDataItem[] => {
  const now = new Date()
  const splitIndex = showRemainingProduction ? forecastPowerData.findIndex(entry => isSameHour(entry.time, now)) + 1 : 0
  const pvForecastWidgetChartData = forecastPowerData.map((fp, index) => ({
    time: fp.time,
    pastPower: index < splitIndex ? fp.power : null,
    futurePower: index >= splitIndex - 1 ? fp.power : null,
  }))

  return pvForecastWidgetChartData
}
